export const aggerApiUrl = process.env.NEXT_PUBLIC_AGGER_API_URL;
export const IS_LOCAL = process.env.NEXT_PUBLIC_ENV === "local";
export const baseUrl =
  process.env.NEXT_PUBLIC_BASE_URL || "http://localhost:3000";

export const cookieOptions = {
  httpOnly: false,
};

export const servicesList = {
  endpoints: "endpoints",
  users: "users",
  events: "events",
  installers: "installers",
  roles: "roles",
  licenses: "licenses",
  auth: "auth",
  admins: "admins",
  incidents: "incidents",
  stats: "stats",
  endpointConfigs: "endpoint-configs",
  companies: "companies",
  permissions: "permissions",
  hashes: "hashes",
  groupConfigs: "group-configs",
};

export const services = new Proxy(servicesList, {
  get: function (target, name: keyof typeof servicesList) {
    return `${aggerApiUrl}/v1/${target[name]}`;
  },
});
